import { render } from "./MandatesTable.vue?vue&type=template&id=7d2826d1&scoped=true"
import script from "./MandatesTable.vue?vue&type=script&lang=js"
export * from "./MandatesTable.vue?vue&type=script&lang=js"

import "./MandatesTable.vue?vue&type=style&index=0&id=7d2826d1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2826d1"]])

export default __exports__